var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53125 3.5V1.96875C4.53125 1.70972 4.74084 1.5 5 1.5H13.5M4.53125 11.7838C4.53125 11.9307 4.53125 13.8174 4.53125 13.7188C4.53125 13.9779 4.74084 14.1875 5 14.1875H10.5",
    stroke: "#0C122A",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20195 7.51234C6.17008 7.43749 6.12446 7.36939 6.06634 7.31233L4.19193 5.47242C3.94756 5.23315 3.55255 5.23315 3.30818 5.47242C3.06381 5.71229 3.06381 6.10064 3.30818 6.33991L4.11632 7.13317H0.624997C0.279378 7.13317 0 7.40801 0 7.74666C0 8.08532 0.279378 8.36016 0.624997 8.36016H4.11629L3.30815 9.15342C3.06378 9.39329 3.06378 9.78164 3.30815 10.0209C3.43003 10.1411 3.59002 10.2007 3.75004 10.2007C3.91006 10.2007 4.07005 10.1412 4.19193 10.0209L6.06634 8.181C6.12446 8.12454 6.17008 8.05645 6.20195 7.98098C6.26506 7.83136 6.26506 7.66203 6.20195 7.51234Z",
    fill: "#0C122A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.46874C14 1.29992 13.8839 1.14428 13.6958 1.0609C13.5077 0.977652 13.2769 0.979849 13.0911 1.06689L8.29109 3.87939C8.11062 3.96398 8 4.11645 8 4.28124V16.5312C8 16.7002 8.11594 16.8558 8.30406 16.9391C8.49172 17.0222 8.72266 17.0203 8.90875 16.9332L13.7088 14.1207C13.8892 14.036 14 13.8835 14 13.7187V1.46874Z",
    fill: "#0C122A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.4d63426cb696e53a090a2314eb701160.svg";
export { ForwardRef as ReactComponent };